import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ArrayContainerWidget: WidgetRegistryEntry = {
  name: "ArrayContainer",
  configuration: () => import("./configuration").then((m) => m.ArrayContainerWidgetConfiguration),
  component: () => import("./array-container-widget.component").then((m) => m.ArrayContainerWidgetComponent)
};
